<template>
  <div>
    <b-row>
      <b-col>
        <h2>
          <span class="ti-settings mr-2"></span>
          {{ $t('message.appSidebar.navItem.account') }}
        </h2>
      </b-col>
    </b-row>
    <b-row class="mt-4">
      <b-col>
        <b-card class="rounded-0">
          <h4 class="text-muted font-weight-normal">
            <span class="ti-id-badge mr-2"></span>
            {{ $t('message.accountDetails.title') }}
          </h4>
          <personal-information-form :personalInfo="personalInfo"
                                     :onDeleteAvatar="deleteAvatar"
                                     :onSubmit="savePersonalInfo"
                                     :onSubmitAvatar="uploadAvatar">
          </personal-information-form>
        </b-card>
      </b-col>
    </b-row>
    <b-row class="mt-4">
      <b-col sm="12" md="12" lg="6">
        <b-card class="rounded-0">
          <h4 class="text-muted font-weight-normal">
            <span class="ti-key mr-2"></span>
            {{ $t('message.accountDetails.card.title.changePassword') }}
          </h4>
          <change-passsword-form :passwordData="passwordData" :onSubmit="saveChangedPassword"></change-passsword-form>
        </b-card>
      </b-col>
      <b-col sm="12" md="12" lg="6" class="mt-sm-4 mt-lg-0">
        <b-card class="rounded-0">
          <h4 class="text-muted font-weight-normal">
            <span class="ti-email mr-2"></span>
            {{ $t('message.accountDetails.card.title.changeEmail') }}
          </h4>
          <account-change-email-form
            ref="accountChangeEmailForm"
            v-on:submit="saveChangedEmail">
          </account-change-email-form>
        </b-card>
      </b-col>
    </b-row>
    <b-row class="mt-4">
      <b-col v-if="isPolicyHolder">
        <b-card class="rounded-0 h-100">
          <h4 class="text-muted font-weight-normal">
            <span class="ti-share-alt mr-2"></span>
            {{ $t('message.accountDetails.card.title.powerOfAttorney') }}
          </h4>
          <account-power-of-attorney-form
            :user="user"
            :onPrintPoaFn="printPoa"
            :onRevokePoaFn="revokePoa">
          </account-power-of-attorney-form>
        </b-card>
      </b-col>
      <b-col>
        <b-card class="rounded-0 h-100">
          <h4 class="text-muted font-weight-normal">
            <span class="ti-archive mr-2"></span>
            {{ $t('message.accountDetails.card.title.deactivate') }}
          </h4>
          <account-deactivation-form
            :onDeactivateFn="deactivateAccount">
          </account-deactivation-form>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
  import AccountDeactivationForm from '@/components/account/AccountDeactivationForm'
  import AccountPowerOfAttorneyForm from '@/components/account/AccountPowerOfAttorneyForm'
  import AccountChangeEmailForm from '@/components/account/AccountChangeEmailForm'
  import ChangePassswordForm from '@/components/account/ChangePasswordForm'
  import PersonalInformationForm from '@/components/account/PersonalInformationForm'
  import utils from '@/utils'

  export default {
    name: 'AccountDetails',
    components: {
      AccountDeactivationForm,
      AccountPowerOfAttorneyForm,
      AccountChangeEmailForm,
      ChangePassswordForm,
      PersonalInformationForm
    },
    computed: {
      isPolicyHolder () {
        const currentUser = this.$store.getters.currentUser
        if (Object.keys(currentUser).length > 0) {
          const rolesPolicyHolder = currentUser.roles.filter(role => role.roleOfUser === 'POLICY_HOLDER')
          if (rolesPolicyHolder.length > 0) {
            return true
          }
        }
        return false
      },
      personalInfo () {
        const user = this.$store.getters.currentUser
        return {
          salutation: user ? user.salutation : '',
          title: user ? user.title : '',
          firstName: user ? user.firstName : '',
          lastName: user ? user.lastName : '',
          dateOfBirth: user ? user.dateOfBirth : ''
        }
      }
    },
    data () {
      return {
        user: this.$store.getters.currentUser,
        passwordData: {
          oldPassword: null,
          newPassword: null,
          newPasswordConfirm: null
        }
      }
    },
    methods: {
      deactivateAccount () {
        this.$store.dispatch('deleteCognitoUser').then(() => {
          this.$router.push('/signin')
        })
      },
      deleteAvatar () {
        return new Promise((resolve, reject) => {
          this.$store.dispatch('deleteAvatar')
            .then(() => {
              this.showSuccessMsg({
                message: this.$t('message.avatar.delete')
              })
              resolve()
            })
            .catch((err) => {
              this.showErrorMsg({
                message: this.$t('error.avatar.delete')
              })
              reject(err)
            })
        })
      },
      printPoa () {
        utils.download(this.$store.getters.powerOfAttorney)
      },
      revokePoa () {
        this.$store.dispatch('deletePowerOfAttorney')
          .then(() => {
            this.showSuccessMsg({
              message: this.$t('message.accountDetails.deletePowerOfAttorney')
            })
          })
          .catch((err) => {
            if (err.response.status === 404) {
              this.showErrorMsg({
                message: this.$t('error.accountDetails.deletePowerOfAttorney.notFound')
              })
            } else {
              this.showErrorMsg({
                message: this.$t('error.accountDetails.deletePowerOfAttorney.common')
              })
            }
          })
      },
      uploadAvatar (avatarFile) {
        return new Promise((resolve, reject) => {
          this.$store.dispatch('uploadAvatar', avatarFile)
            .then(() => {
              this.showSuccessMsg({
                message: this.$t('message.avatar.upload')
              })
              resolve()
            })
            .catch((err) => {
              this.showErrorMsg({
                message: this.$t('error.avatar.uploadFail')
              })
              reject(err)
            })
        })
      },
      savePersonalInfo (personalInfo) {
        const user = this.$store.getters.currentUser
        user.firstName = personalInfo.firstName
        user.lastName = personalInfo.lastName
        user.title = personalInfo.title
        user.salutation = personalInfo.salutation
        user.dateOfBirth = personalInfo.dateOfBirth
        return new Promise((resolve, reject) => {
          this.$store.dispatch('updateUser', user)
            .then(() => {
              this.showSuccessMsg({
                message: this.$t('message.accountDetails.savePersonalInfo')
              })
              resolve()
            })
            .catch((err) => {
              reject(err)
            })
        })
      },
      saveChangedEmail (email) {
        this.$store.dispatch('changeEmail', email)
          .then(() => {
            this.$refs.accountChangeEmailForm.reset()
            this.showSuccessMsg({
              message: this.$t('message.accountDetails.saveChangedEmail')
            })
          })
          .catch(() => {
            this.showErrorMsg({
              message: this.$t('error.accountDetails.saveChangedEmail')
            })
          })
      },
      saveChangedPassword (passwordData) {
        return new Promise((resolve, reject) => {
          this.$store.dispatch('changePassword', passwordData)
            .then(() => {
              this.passwordData = {
                oldPassword: null,
                newPassword: null,
                newPasswordConfirm: null
              }

              this.showSuccessMsg({
                message: this.$t('message.accountDetails.saveChangedPassword')
              })

              resolve()
            })
            .catch((err) => {
              if (err && err.code === 'LimitExceededException') {
                this.showErrorMsg({
                  message: this.$t('error.accountDetails.saveChangedPassword.limitExceeded')
                })
              } else {
                this.showErrorMsg({
                  message: this.$t('error.accountDetails.saveChangedPassword.common')
                })
              }
              reject(err)
            })
        })
      }
    },
    notifications: {
      showSuccessMsg: {
        type: 'success'
      },
      showErrorMsg: {
        type: 'error'
      }
    }
  }
</script>




// WEBPACK FOOTER //
// src/components/account/AccountDetails.vue